export const tijeu = {
  logo_image_url: 'tijeu/default.png',
  header_full_height: true,
  token_url: 'tijeu/jaune.svg',
  number_hidden: true,
  button_color: '#f5ea20',
  button_text_color: 'black',
  button_radius: 50,
  button_half_border_color: '#f5ea20',
}

export const tijeu_bleu = {
  ...tijeu,
  logo_image_url: 'tijeu/bleu.png',
  token_url: 'tijeu/bleu.svg',
  button_color: '#418faf',
  button_half_border_color: '#418faf',
}

export const tijeu_gris = {
  ...tijeu,
  logo_image_url: 'tijeu/gris.png',
  token_url: 'tijeu/gris.svg',
  button_color: '#e5e5e4',
  button_half_border_color: '#e5e5e4',
}

export const tijeu_jaune = {
  ...tijeu,
  logo_image_url: 'tijeu/jaune.png',
}

export const tijeu_mauve = {
  ...tijeu,
  logo_image_url: 'tijeu/mauve.png',
  token_url: 'tijeu/mauve.svg',
  button_color: '#423d7c',
  button_half_border_color: '#423d7c',
}

export const tijeu_orange = {
  ...tijeu,
  logo_image_url: 'tijeu/orange.png',
  token_url: 'tijeu/orange.svg',
  button_color: '#f68a46',
  button_half_border_color: '#f68a46',
}

export const tijeu_rose = {
  ...tijeu,
  logo_image_url: 'tijeu/rose.png',
  token_url: 'tijeu/rose.svg',
  button_color: '#dc7f7f',
  button_half_border_color: '#dc7f7f',
}

export const tijeu_rouge = {
  ...tijeu,
  logo_image_url: 'tijeu/rouge.png',
  token_url: 'tijeu/rouge.svg',
  button_color: '#ef3e3c',
  button_half_border_color: '#ef3e3c',
}

export const tijeu_vert = {
  ...tijeu,
  logo_image_url: 'tijeu/vert.png',
  token_url: 'tijeu/vert.svg',
  button_color: '#49b590',
  button_half_border_color: '#49b590',
}
